<ul class="com-month-picker-wrapper">
    <li class="com-picker-item" [ngClass]="{'com-m-y-disabled':month?.date>max||min>month?.date}" (click)="monthClick(month.value)" *ngFor="let month of monthList"><span>{{month.text}}</span></li>
</ul>
